import styled from 'styled-components';
import { media, layout } from 'src/components/base';
import { Link } from 'react-router-dom';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Body = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: ${layout.measurements.spacing050};
  color: ${p => p.theme.colors.base500};
`;

export const Footer = styled.div`
  margin: ${layout.measurements.spacing100} 0;
`;

export const ProductLink = styled(Link)`
  color: ${p => p.theme.text.callToAction};
  text-decoration: underline;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const BreadCrumbWrapper = styled.div`
  display: flex;
  margin: ${layout.measurements.spacing050} 0 ${layout.measurements.spacing050}
    ${layout.measurements.spacing050};

  ${media.smallOnly`
    margin-left: 0;
  `}
`;

export const Content = styled.div`
  padding-left: ${layout.measurements.spacing050};
  padding-right: ${layout.measurements.spacing050};
`;
